import { ReactNode } from 'react';
import {
  FormControl,
  Checkbox as MuiCheckbox,
  // RadioGroup as MuiRadioGroup,
} from '@mui/material';
import { modifiers } from '@outdoria/ui';

import s from './CheckboxGroup.module.scss';

type CheckboxGroupProps<V> = {
  name: string;
  label?: string;
  value: V[];
  setValue: (value: V[]) => void;
  data: { value: V; label: ReactNode; disabled?: boolean }[];
};
export const CheckboxGroup = <V extends string>({
  name,
  label,
  value,
  setValue,
  data,
}: CheckboxGroupProps<V>) => {
  const onChange = (itemValue: V, checked: boolean) => {
    if (!setValue) return;

    if (checked) {
      // Add checked item to array
      setValue([...value, itemValue]);
    } else {
      // Remove unchecked item from array
      setValue(value.filter(entity => entity !== itemValue));
    }
  };

  return (
    <FormControl id="checkbox-group" className={s.checkboxGroup__wrapper}>
      {label && (
        <label htmlFor="checkbox-group" className={s.checkboxGroup__label}>
          {label}
        </label>
      )}
      <div className={s.checkboxGroup__group}>
        {data.map(item => (
          <div
            className={modifiers(s, 'checkbox__wrapper', {
              isChecked: value.includes(item.value),
            })}>
            <MuiCheckbox
              disabled={item.disabled}
              icon={item.label}
              checkedIcon={item.label}
              checked={value.includes(item.value)}
              onChange={(_, checked) => onChange(item.value, checked)}
              classes={{
                root: modifiers(s, 'checkbox', {
                  isChecked: value.includes(item.value),
                }),
              }}
            />
          </div>
        ))}
      </div>
    </FormControl>
  );
};
